import { SERVICE, type ServiceType } from '@musinsa/packages-device-detection';
import { executeStandardRequest, type MusinsaStandardResponse } from '@musinsa/packages-http';
import { z } from 'zod';
import { createCookieStore } from '../auth';
import { getCuratorApiBaseURL } from '../utils/getCuratorApiBaseURL';
import { registrationApiPath } from './apiPath';

const CheckRegistrationResponseSchema = z
  .object({
    registered: z.boolean(),
  })
  .describe('CheckRegistrationResponseSchema');

export type CheckRegistrationResponse = MusinsaStandardResponse<
  z.infer<typeof CheckRegistrationResponseSchema>
>;

/** x-platform 헤더 값: MUSINSA | 29CM  */
export type CheckRegistrationPlatform = 'MUSINSA' | '29CM';

export const checkRegistrationWithCookie = (
  cookieHeader: string,
  xPlatform: CheckRegistrationPlatform,
) =>
  executeStandardRequest(async () => {
    const baseUrl = getCuratorApiBaseURL(xPlatform as ServiceType);
    const url = `${baseUrl}${registrationApiPath.checkRegistration}`;

    const cookieStore = createCookieStore({}, cookieHeader);
    const deviceId = cookieStore.get('x-device-id') ?? '';
    const baseHeaders: Record<string, string> = {
      Cookie: cookieHeader,
      'Content-Type': 'application/json',
      'x-platform': xPlatform,
    };

    if (!deviceId || xPlatform !== SERVICE['29CM']) {
      const response = await fetch(url, {
        method: 'GET',
        headers: baseHeaders,
        credentials: 'include',
        cache: 'no-store',
      });

      return (await response.json()) as CheckRegistrationResponse;
    }

    const response = await fetch(url, {
      method: 'GET',
      headers: {
        ...baseHeaders,
        'x-device-id': cookieStore.get('x-device-id') ?? '',
        Authorization: `Bearer ${cookieStore.get('access_token') ?? ''}`,
      },
      credentials: 'include',
      cache: 'no-store',
    });

    return (await response.json()) as CheckRegistrationResponse;
  });
